export const experiences = [
    {
        id: 'BNYM',
        company: 'BNY',
        displayName: 'BNY',
        shortName: 'BNY',
        position: 'Senior Associate — Full Stack App Developer',
        period: "February 2023 – Present",
        lineDate: "2023",
        tags: ['Angular', 'Spring Boot', 'AI Agents', 'Kubernetes'],
        duties: [
            'Built end-to-end AI apps on Eliza (BNY’s AI platform)—agents, workflow automation, and executive-facing financial tools with 100%+ productivity gains.',
            'Shipped full-stack Angular/TypeScript + Spring Boot/Java 17 applications with CI/CD on GitLab, Docker, Kubernetes, and AppEngine.',
            'Co-invented a patented scenario-based financial modeling solution; mentored two intern teams and interviewed 100+ developer candidates.',
        ],
        tabOffset: 0
    },
    {
        id: 'FourCStrategies',
        company: '4c Strategies',
        displayName: '4c Strategies',
        shortName: '4c Strat.',
        position: 'Software Developer',
        period: "May 2022 – February 2023",
        lineDate: "2022",
        tags: ['Angular', 'STE', 'Java', 'MySQL'],
        duties: [
            'Designed and built a full-stack app for the U.S. Army’s portable Synthetic Training Environment (STE) using Angular, TypeScript, Spring Boot, and MySQL.',
            'Modernized the U.S. Marines Wargaming platform—new features, defect fixes, and performance improvements.',
            'Owned architecture and technical docs while collaborating with product owners and government stakeholders in Agile Scrum.',
        ],
        tabOffset: 42
    },
    {
        id: 'PhoenixDefense',
        company: 'Phoenix Defense',
        displayName: 'Phoenix Defense',
        shortName: 'Phoenix',
        position: 'Jr. Software Developer',
        period: "May 2021 – May 2022",
        lineDate: "2021",
        tags: ['ATAK', 'Mesh IoT', 'Spring Boot', 'Angular'],
        duties: [
            'Led an ATAK-integrated Land Navigation app with peer-to-peer mesh networking for field location tracking without centralized infrastructure.',
            'Added Google Maps geospatial views for live personnel, routes, and operational data.',
            'Architected an enterprise asset-management system (Spring Boot + Angular) with RBAC and warranty automation across military installations.',
        ],
        tabOffset: 84
    },
    {
        id: 'DignitasTechnologies',
        company: 'Dignitas Technologies',
        displayName: 'Dignitas Technologies',
        shortName: 'Dignitas',
        position: 'Software Developer Intern',
        period: "July 2019 – April 2020",
        lineDate: "2019",
        tags: ['Java', 'SQL', 'GWT', 'Simulations'],
        duties: [
            'Built Java/SQL/GWT tools that ingested and validated multi-source data for military training simulations.',
            'Ran field QA in operational training environments—logged defects in Jira and verified fixes before release.',
        ],
        tabOffset: 126
    }
];

export const technologies = [
    ['Java', 'TypeScript', 'JavaScript', 'SQL', 'Python', 'Kotlin'],
    ['Spring Boot', 'Angular', 'React', 'React Native', 'Ionic'],
    ['Agentic AI', 'LLM Integration', 'Oracle', 'MySQL', 'MongoDB'],
    ['Docker', 'Kubernetes', 'GitLab CI/CD', 'AWS', 'Git']
];
